export default {"src":"/_next/static/media/preferences.48c0ff90.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};